<template>
  <v-col>
    <v-card
        class="pa-2"
        outlined
        tile
    >
      <h2 class="subtitle-1">Models</h2>
      <v-list
          v-for="(count, model) in models"
          :key="model"
      >
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{ count }}</v-list-item-title>
            <v-list-item-subtitle>{{ model }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "model",
  props: {
    models: {
      required: true,
      type: Object,
    }
  }
}
</script>
